import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './AppMain';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("CRITICAL ERROR: Could not find element with id 'root' in index.html");
}